const state = {
  devices: []
}

const getters = {
  devices: (state) => state.devices,
}

const actions = {
  'SOCKET_nfc.attached': (context, payload) => {
    console.log(payload)
  },
  'SOCKET_nfc.dettached': (context, payload) => {
    console.log(payload)
  },
  'SOCKET_nfc.read': (context, payload) => {
    console.log(payload)
  },
  'SOCKET_nfc.read.off': (context, payload) => {
    console.log(payload)
  },
  'SOCKET_nfc.error': (context, payload) => {
    console.log(payload)
  },
}

const mutations = {
  error: (state, device) => { 
    state.devices.push(device)
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
